import { render, staticRenderFns } from "./TheAppBarCrumbs.vue?vue&type=template&id=2fb80cc2&"
import script from "./TheAppBarCrumbs.vue?vue&type=script&lang=js&"
export * from "./TheAppBarCrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports